import {
	Details,
	Image,
	//  Member,
	Name,
	NameSub,
	Position,
	//  ThreeCols,
	TwoCols,
} from '../components/atoms/TeamObjs';
import { WhiteBackLayer } from '../components/layout/BackgroundLayer';
import { SingleLayout } from '../components/layout/SingleLayout';

export const TeamBackLayer = () => {
	return null;
};

export const TeamPage = () => {
	return (
		<div>
			<WhiteBackLayer />

			<SingleLayout maxWidth='lg'>
				<h1 className='text-xl text-center font-sans italic text-rose-700 '>Team</h1>

				<div className='mt-12 md:mt-20'>
					<TwoCols>
						<Image src='./images/team/shoda_ryo.jpg' alt='' />
						<div>
							<Name>Shoda Ryo</Name>
							<NameSub>庄田 竜</NameSub>
							<Details>
								<Position>株式会社庄田竜事務所 代表取締役社長</Position>
								<p>人々のライフスタイルに衝撃を。</p>
								<p>講演実績として東京大学/京都大学/神戸大学/法政大学/関西学院大学</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/uozumi_mihoko.jpg' alt='' />
						<div>
							<Name>Uozumi Mihoko</Name>
							<NameSub>魚住 美保子</NameSub>
							<Details>
								<Position>
									株式会社庄田竜事務所本部
									<br />
									NPO法人 次世代リーダー相談所代表理事
									<br />
									R&Mストラテジー代表
								</Position>
								<p>
									24歳から延べ4万人近くの青年達の指導に関わる。現在もスケジュールが空けば相談というライフスタイルを過ごす。キャリア相談、人生相談、経営相談のボランティアのデーターベースは膨大であり、その他、いろいろな業界のスペシャリストのマーケティング、多くの経営者や行政関係者から支援のもと、次世代リーダー相談所を事業として還暦越えても挑戦し続ける覚悟で、事業設立を決意しました。自身の生涯をかけ「1人でも多くの次世代リーダー輩出に貢献したい」、社会で自己実現するには、お金と時間、経済、経営知識とスキルの重要性を拡散し続けるため、日夜活動し続けております。
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/kashimoto.jpg?20250820' alt='' />
						<div>
							<Name>Yuuki Kashimoto</Name>
							<NameSub>樫本 祐輝</NameSub>
							<Details>
								<Position>
									ARクリエイティブ責任者
									<br />
									Creative Universe Inc 代表取締役社長
								</Position>
								<p>
									理念：クリエイティブな人に幸せを。
									<br />
									21歳でWebデザイナーとして独立。その後ゲーム会社、マーケティング会社、NPO法人などを渡り歩く。上場を目指す企業のWebサービスのUXデザインや中小企業のDX顧問、一等地にある商業施設のITアドバイザーなど務める。
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/terashima.jpg?20250820' alt='' />
						<div>
							<Name>Yusuke Terashima</Name>
							<NameSub>寺嶋 悠輔　</NameSub>
							<Details>
								<Position>ALL ROUNDER Aクラス審査部</Position>
								<p>
									元東京都中学校教諭(三鷹市技術家庭科部長)、日本経営協会登録講師、(株)グローバルキッズ事業開発部を経て、保険系大手内資系金融機関グループ会社勤務
									グローバルキッズ時代に企業主導型保育施設の設置運営、M&A、プラットホーム新規事業を企画立案し現職先に事業継承。出向転籍にて現職。
									<br />
									趣味:子育て、サッカー観戦、落語鑑賞
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/furuta.jpg?20230728' alt='' />
						<div>
							<Name>Furuta Hiroyuki</Name>
							<NameSub>古田 寛幸</NameSub>
							<Details>
								<Position>
									ALL ROUNDER 審査部責任者
									<br />
									ALL ROUNDER B.Cクラス審査部
									<br />
									株式会社自分自身 代表取締役
								</Position>
								<p>
									人々の心に火を灯す。
									<br />
									元プロサッカー選手
									<br />
									Jリーグ通算239試合出場
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/shintani_izumi.jpg' alt='' />
						<div>
							<Name>Shintani Izumi</Name>
							<NameSub>新谷 和実</NameSub>
							<Details>
								<Position>
									ALL ROUNDER 審査部
									<br />
									NPO法人The Peace Front 代表理事
									<br />
									株式会社The Peace Front 代表取締役
								</Position>
								<p>
									理念：より良い社会を実現し続ける
									<br />
									ビジョン：社会課題解決の量と質を高める 他<br />
									東京大学大学院生（インパクト評価研究）
									<br />
									途上国向け行政プロジェクト参画
									<br />
									大学連合事務局員（産官学民連携）
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/inoue_yusei.jpg' alt='' />
						<div>
							<Name>Inoue Yusei</Name>
							<NameSub>井上 友聖</NameSub>
							<Details>
								<Position>
									ALL ROUNDER 審査部
									<br />
									（一社）少年PROJECT 創業 代表理事
									<br />
									AR ACADEMY代表
								</Position>
								<p>
									理念：解き放つ人生を提供
									<br />
									ビジョン：エンタメ・教育・居場所を通して国内の幸福度を上げる
									<br />
									うみぞら映画祭2024/2025 運営本部補助
									<br />
									大阪・淡路島での若者に向けた居場所の提供
									<br />
									多方面でのエンターテイメント演出・企画・照明を担当（Zeppなんば/能勢電鉄/梅田サウスホール/川西バイブルキャンプ場etc）
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/hano_ryota.jpg' alt='' />
						<div>
							<Name>Hano Ryota</Name>
							<NameSub>杷野 稜大</NameSub>
							<Details>
								<Position>ALL ROUNDER 審査部</Position>
								<p>
									理念：人生に生きがいを届ける
									<br />
									ビジョン：大人のキッザニアを作る
									<br />
									NPO法人次世代リーダー相談所 PRアシスタント
									<br />
									All Rounder Tクラス運営
									<br />
									Ted Talk U-Tokyo Speaker
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/yamaoka_genta.png' alt='' />
						<div>
							<Name>Yamaoka Genta</Name>
							<NameSub>山岡 弦太</NameSub>
							<Details>
								<Position>ALL ROUNDER 審査部</Position>
								<p>
									理念：挑戦が続く物語を創る。
									<br />
									ビジョン：隠れた魅力を発掘し、地元から日本を盛り上げる。
									<br />
									All Rounder Tクラス運営
									<br />
									日本舞踊を含む、伝統文化活動
								</p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/antoniantz_taiga.jpg' alt='' />
						<div>
							<Name>Antoniantz Taiga</Name>
							<NameSub>アントニアンズ 大我</NameSub>
							<Details>
								<Position>ALL ROUNDER 審査部</Position>
								<p></p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/kugimiya.jpg' alt='' />
						<div>
							<Name>Kugimiya Mitsumasa</Name>
							<NameSub>釘宮 光政</NameSub>
							<Details>
								<Position>会計士</Position>
								<p></p>
							</Details>
						</div>
					</TwoCols>

					<TwoCols>
						<Image src='./images/team/iwasaki_akihiro.jpg' alt='' />
						<div>
							<Name>Iwasaki Akihiro</Name>
							<NameSub>岩崎 章浩</NameSub>
							<Details>
								<Position>
									弁護士 弁理士
									<br />
									法律事務所HEROリーガルグループ 代表弁護士
								</Position>
								<p>
									スタートアップ法務（資金調達、上場支援）、AIを含むTechnology法務、ヘルスケアビジネス（医療・介護）、知財法務を得意とする。ほか、大学における学生の指導、ビジネスを促進するための戦略的アドバイス、投資等を行う。
								</p>
							</Details>
						</div>
					</TwoCols>
				</div>

				{/* <div className="mt-12 md:mt-20">
          <ThreeCols>
            <Member
              imgSrc="./images/team/ph150x150.png"
              job="Web Developer"
              name="その他メンバー"
            />
          </ThreeCols>
        </div> */}
			</SingleLayout>
		</div>
	);
};
